import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-workplace-department',
  templateUrl: './workplace-department.component.html',
  styleUrls: ['./workplace-department.component.scss']
})
export class WorkplaceDepartmentComponent implements OnInit {

  @Input() id:string;
  @Input() company:any = {};

  constructor() { }

  ngOnInit() {
  }

}
